// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HCIVs","name":"styles_name__2-URN","phone":"styles_phone__3XtfB"};